import React from 'react';
import { Box } from '../../../CommonComponents/OPL/Box/Box';
import { Card } from '../../../CommonComponents/OPL/Card/Card';
import { Text } from '../../../CommonComponents/OPL/Text/Text';

interface Props {
  title: string;
  children: React.ReactNode;
}

export const SettingsSection = ({ title, children }: Props) => {
  if (!children) {
    return null;
  }

  return (
    <Card as="section" hasBorder p="24" mb="24">
      <Text as="h2" fontSize="h4" fontWeight={600} color="neutral.600" mb="24">
        {title}
      </Text>

      <Box
        display="grid"
        css={({ theme }) => ({
          gridTemplateColumns: 'repeat(3, 1fr)',
          rowGap: theme.space[32],
          columnGap: theme.space[48],
        })}
      >
        {children}
      </Box>
    </Card>
  );
};
